// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.it-consulting-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 50px;
  padding-bottom: 0px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  gap: 20px;
}

.it-consulting-image {
  position: relative;
  width: 35%;
  order: 2;
  margin-top: 0px;
  width: 40%;
  height: auto;
  border-radius: 8px;
  margin-top: 0;
}

.it-consulting-text {
  width: 60%;
  order: 1;
  margin-bottom: 110px;
}

.it-consulting-text h1 {
  font-size: 2em;
  color: #000;
  margin-bottom: 15px;
}
.it-consulting-text h2 {
  font-size: 1.5em;
  color: #555;
  margin-bottom: 15px;
}

.it-consulting-text p {
  font-size: 1.1em;
  color: #555;
  margin-bottom: 20px;
}

.services-list {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  list-style: none;
  padding: 0;
}

.services-list li {
  width: 45%;
  font-size: 1em;
  color: #333;
}

.it-consulting-button {
  background-color: #00c853;
  color: white;
  border: none;
  padding: 12px 25px;
  font-size: 1.1em;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 20px;
  transition: background-color 0.3s ease;
}

.it-consulting-button:hover {
  background-color: #009624;
}

@media (max-width: 768px) {
  .it-consulting-container {
    flex-direction: column;
    align-items: center;
    text-align: left;
    gap: 20px;
    padding: 40px;
  }

  .it-consulting-text {
    margin-top: -40px;
    width: 100%;
    order: 2;
  }

  .it-consulting-image {
    margin-top: 100px;
    width: 100%;
    order: 1;
  }

  .services-list li {
    width: 100%;
  }
}

@media screen and (min-width: 1380px) and (max-width: 1919px) {
  .it-consulting-container {
    padding: 75px;
    gap: 15px;
  }

  .it-consulting-text {
    margin-bottom: 90px;
  }

  .it-consulting-text h1 {
    font-size: 2.2em;
  }

  .it-consulting-text h2 {
    font-size: 1.4em;
  }

  .it-consulting-text p {
    font-size: 1em;
  }

  .it-consulting-image {
    width: 34%;
  }

  .services-list li {
    width: 48%;
  }

  .it-consulting-button {
    padding: 10px 20px;
    font-size: 1em;
  }
}

@media screen and (min-width: 1920px) {
  .it-consulting-container {
    padding: 60px;
    gap: 25px;
  }

  .it-consulting-text {
    margin-bottom: 120px;
  }

  .it-consulting-text h1 {
    font-size: 2.8em;
  }

  .it-consulting-text h2 {
    font-size: 1.6em;
  }

  .it-consulting-text p {
    font-size: 1.2em;
  }

  .it-consulting-image {
    width: 35%;
  }

  .services-list li {
    width: 45%;
  }

  .it-consulting-button {
    padding: 15px 30px;
    font-size: 1.2em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ITConsulting/ITConsulting.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,eAAe;EACf,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,cAAc;EACd,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACF","sourcesContent":[".it-consulting-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 50px;\n  padding-bottom: 0px;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  gap: 20px;\n}\n\n.it-consulting-image {\n  position: relative;\n  width: 35%;\n  order: 2;\n  margin-top: 0px;\n  width: 40%;\n  height: auto;\n  border-radius: 8px;\n  margin-top: 0;\n}\n\n.it-consulting-text {\n  width: 60%;\n  order: 1;\n  margin-bottom: 110px;\n}\n\n.it-consulting-text h1 {\n  font-size: 2em;\n  color: #000;\n  margin-bottom: 15px;\n}\n.it-consulting-text h2 {\n  font-size: 1.5em;\n  color: #555;\n  margin-bottom: 15px;\n}\n\n.it-consulting-text p {\n  font-size: 1.1em;\n  color: #555;\n  margin-bottom: 20px;\n}\n\n.services-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px;\n  list-style: none;\n  padding: 0;\n}\n\n.services-list li {\n  width: 45%;\n  font-size: 1em;\n  color: #333;\n}\n\n.it-consulting-button {\n  background-color: #00c853;\n  color: white;\n  border: none;\n  padding: 12px 25px;\n  font-size: 1.1em;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 20px;\n  transition: background-color 0.3s ease;\n}\n\n.it-consulting-button:hover {\n  background-color: #009624;\n}\n\n@media (max-width: 768px) {\n  .it-consulting-container {\n    flex-direction: column;\n    align-items: center;\n    text-align: left;\n    gap: 20px;\n    padding: 40px;\n  }\n\n  .it-consulting-text {\n    margin-top: -40px;\n    width: 100%;\n    order: 2;\n  }\n\n  .it-consulting-image {\n    margin-top: 100px;\n    width: 100%;\n    order: 1;\n  }\n\n  .services-list li {\n    width: 100%;\n  }\n}\n\n@media screen and (min-width: 1380px) and (max-width: 1919px) {\n  .it-consulting-container {\n    padding: 75px;\n    gap: 15px;\n  }\n\n  .it-consulting-text {\n    margin-bottom: 90px;\n  }\n\n  .it-consulting-text h1 {\n    font-size: 2.2em;\n  }\n\n  .it-consulting-text h2 {\n    font-size: 1.4em;\n  }\n\n  .it-consulting-text p {\n    font-size: 1em;\n  }\n\n  .it-consulting-image {\n    width: 34%;\n  }\n\n  .services-list li {\n    width: 48%;\n  }\n\n  .it-consulting-button {\n    padding: 10px 20px;\n    font-size: 1em;\n  }\n}\n\n@media screen and (min-width: 1920px) {\n  .it-consulting-container {\n    padding: 60px;\n    gap: 25px;\n  }\n\n  .it-consulting-text {\n    margin-bottom: 120px;\n  }\n\n  .it-consulting-text h1 {\n    font-size: 2.8em;\n  }\n\n  .it-consulting-text h2 {\n    font-size: 1.6em;\n  }\n\n  .it-consulting-text p {\n    font-size: 1.2em;\n  }\n\n  .it-consulting-image {\n    width: 35%;\n  }\n\n  .services-list li {\n    width: 45%;\n  }\n\n  .it-consulting-button {\n    padding: 15px 30px;\n    font-size: 1.2em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
